import AjaxRequest from "../modules/ajax-request";
import Cookies from 'js-cookie';

class CheckUserLogged {
    constructor(element) {
        this._element = element;
        this._div = element[0] ?? element;
        this._id = "";
        this._urlCheckUserLogged = "";
        this._forceCheck = "";

        this.getData();
        this.clearData();
        this.init();
    }

    getData() {
        [this._id, this._urlCheckUserLogged, this._forceCheck] = Object.values(this._div.dataset);
    }

    clearData() {
        Object.keys(this._div.dataset).forEach(dataKey => {
            if (dataKey !== "id") {
                delete this._div.dataset[dataKey];
            }
        });
    }

    init() {
        if ((parseInt(Cookies.get("cs_logged")) === 1) || (this._forceCheck === 1)) {
            this.checkUserLogged();
        } else {
            this.resolveUserNotLogged();
        }
    }

    checkUserLogged() {
        let _this = this;
        let _ajaxRequest = new AjaxRequest({
            successCallback: function (data) {
                if (data.userLogged) {
                    _this.resolveUserLogged(data)
                } else {
                    _this.resolveUserNotLogged()
                }
            }
        });
        _ajaxRequest.makeCall(this._urlCheckUserLogged);
    }

    resolveUserNotLogged() {
        let _event = new CustomEvent("user_not_logged");
        Cookies.remove("cs_logged");
        Cookies.remove("cs_adv");
        document.dispatchEvent(_event);
        this.resolveEntityWithNoShowBanners();
    }

    resolveUserLogged(data) {
        let _event = new CustomEvent("user_logged");
        document.dispatchEvent(_event);
        if (data.userHasActivePaymentSubscription) {
            this.resolveUserHasActivePaymentSubscription();
        } else {
            this.resolveUserNoHasActivePaymentSubscription();
        }
    }

    resolveUserHasActivePaymentSubscription() {
        let _event = new CustomEvent("user_has_payment_subscription");
        document.dispatchEvent(_event);
        this.noShowBanners();
    }

    resolveUserNoHasActivePaymentSubscription() {
        let _event = new CustomEvent("user_no_has_payment_subscription");
        document.dispatchEvent(_event);
        this.resolveEntityWithNoShowBanners();
    }

    resolveEntityWithNoShowBanners() {
        let _noShowBanners = document.querySelectorAll('[data-no-show-banners]');
        if (_noShowBanners.length === 0) {
            this.showBanners();
        } else {
            let _showBanners = true;
            _noShowBanners.forEach((el) => {
                let _value = el.getAttribute('data-no-show-banners');
                _value = parseInt(_value);
                if (_value === 1) {
                    _showBanners = false;
                }
            });
            if (_showBanners) {
                this.showBanners();
            } else {
                this.noShowBanners();
            }
        }
    }

    noShowBanners() {
        let _event = new CustomEvent("no_show_banners");
        document.dispatchEvent(_event);
    }

    showBanners() {
        let _event = new CustomEvent("show_banners");
        document.dispatchEvent(_event);
    }
}

export default CheckUserLogged